import { Alert, Button } from "react-bootstrap";
import { Modal, MuniSpinner2 } from "../../../components";
import { useGeneralAppStore } from "../../../store/generalAppStore";
import useActas from "../../../api/actas";

const ModalDesasignarActa = ({ modals, handlerModal, actaADesasignar, setRefetch }) => {

    //~ ESTADOS GLOABLES
    const { loads } = useGeneralAppStore();

    //TODO API
    const { quitarNotificadorAsignado } = useActas();
    // console.log(loads)

    return (
        <>
            <Modal
                backdrop={true}
                show={modals.includes("modal_desasignar_acta")}
                size="md"
                onHide={() => {
                    handlerModal({ modal: false, modalName: "modal_desasignar_acta" });
                }}
                title={() => "Confirmar"}
            >
                <div
                    className="d-flex flex-column  align-items-center     position-relative "
                >
                    <Alert variant="danger" className="w-100">
                        Quiere <b>desasignar</b> a <b>{actaADesasignar.notificador_nombre}</b> del acta <b>{actaADesasignar.numero_acta}</b> ?
                    </Alert>
                    {loads.includes("desasignar_notificador") && (
                        <div
                            className="position-absolute w-100 h-100 d-flex justify-content-center alig-items-center z-3 "
                            style={{ backgroundColor: "rgba(255,255,255,0.7)" }}
                        >
                            <MuniSpinner2 />
                        </div>
                    )}
                    <div className="d-flex  justify-content-end w-100 gap-2">
                        <Button
                            onClick={() => {
                                quitarNotificadorAsignado({
                                    acta_id: actaADesasignar.id,
                                    user_id_asignado: actaADesasignar.user_id_asignado,
                                }, setRefetch);
                            }}
                            size="sm"
                            variant="danger"
                        >
                            Confirmar
                        </Button>
                        <Button
                            onClick={() => { handlerModal({ modal: false, modalName: "modal_desasignar_acta" }) }}
                            size="sm"
                            variant="primary"
                        >
                            Cancelar
                        </Button>
                    </div>
                </div>
            </Modal >
        </>
    );
};
export default ModalDesasignarActa;
